import React from 'react'
import { useTranslate } from './TranslationText'

export default function HorseResultsTable({ showbyIdData, showsLoading, showClassHorseSoringDetailsData, item3 }) {
    const { translate } = useTranslate();

    return (
        <div className="col-md-12 px-0 scrolableTable ">
            <table className="table table-striped table-bordered">
                <thead
                    className="text-white"
                >
                    <tr>
                        <th className=""></th>
                        <th className="text-center">
                            {translate(
                                "web.type",
                                "Type"
                            )}
                        </th>
                        {!!showbyIdData &&
                            !showsLoading &&
                            showbyIdData?.isHeadNeakType && (
                                <React.Fragment>
                                    <th className="text-center">
                                        {translate(
                                            "web.head",
                                            "Head"
                                        )}
                                    </th>
                                    <th className="text-center">
                                        {translate(
                                            "web.neck",
                                            "Neck"
                                        )}
                                    </th>
                                </React.Fragment>
                            )}
                        <th className="text-center">
                            {translate(
                                "web.hn",
                                "H&N"
                            )}
                        </th>
                        <th className="text-center">
                            {translate(
                                "web.body",
                                "Body"
                            )}
                        </th>
                        <th className="text-center">
                            {translate(
                                "web.legs",
                                "Legs"
                            )}
                        </th>
                        <th className="text-center">
                            {translate(
                                "web.movement",
                                "Movement"
                            )}
                        </th>
                        <th className="text-center bold">
                            {translate(
                                "web.totalPoints",
                                "Total Points"
                            )}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {!!showClassHorseSoringDetailsData?.scoringTable &&
                        showClassHorseSoringDetailsData?.scoringTable.length >
                        0 ? (
                        showClassHorseSoringDetailsData?.scoringTable.map(
                            (
                                itemScoring,
                                iScoring
                            ) => (
                                <tr key={iScoring} className="fw-bold">
                                    <td className="text-white text-center" style={{ background: `var(--bgGray)` }}>
                                        {itemScoring.judgeLetter}
                                    </td>
                                    <td className="text-center" style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring?.isTypeValueEliminated ? <s>{itemScoring.type}</s> : itemScoring.type}
                                    </td>
                                    {!!showbyIdData &&
                                        !showsLoading &&
                                        showbyIdData?.isHeadNeakType && (
                                            <React.Fragment>
                                                <td className="text-center" style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                                    {itemScoring.head}
                                                </td>
                                                <td className="text-center" style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                                    {itemScoring.neck}
                                                </td>
                                            </React.Fragment>
                                        )}
                                    {/* isMoveValueEliminated isLegValueEliminated    */}
                                    <td className="text-center" style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring?.isHeadNeckValueEliminated ? <s>{itemScoring.headNeck}</s> : itemScoring.headNeck}
                                    </td>
                                    <td className="text-center" style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring?.isBodyValueEliminated ? <s>{itemScoring.body}</s> : itemScoring.body}
                                    </td>
                                    <td className="text-center" style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring?.isLegValueEliminated ? <s>{itemScoring.leg}</s> : itemScoring.leg}
                                    </td>
                                    <td className="text-center" style={{ background: iScoring % 2 == 0 ? '#fff' : 'transparent' }}>
                                        {itemScoring?.isMoveValueEliminated ? <s>{itemScoring.move}</s> : itemScoring.move}
                                    </td>
                                    {iScoring ===
                                        0 && (
                                            <td
                                                className="fw-bold text-white"
                                                rowSpan={showClassHorseSoringDetailsData?.scoringTable?.length}
                                                style={{
                                                    background: `var(--bgGray)`,
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                <span>
                                                    {item3?.totalPoint > 0 ? Number(item3?.totalPoint ?? 0).toFixed(2):''} {item3?.TotalScore >0 ? Number(item3?.TotalScore ?? 0).toFixed(2):''}
                                                </span>
                                                <br />
                                                <span>
                                                    {translate(
                                                        "web.points",
                                                        "POINTS"
                                                    )}
                                                </span>
                                            </td>
                                        )}
                                </tr>
                            )
                        )
                    ) : (
                        <tr>
                            <td
                                colSpan={!!showbyIdData &&
                                    !showsLoading &&
                                    showbyIdData?.isHeadNeakType
                                    ? 9
                                    : 7}
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                <span className="text-danger text-center">
                                    {translate(
                                        "web.nodataFound",
                                        "No Data Found !"
                                    )}
                                </span>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <sub className="ms-3 fw-bold rtl">
                {translate('web.judges', 'Judges')}: {showClassHorseSoringDetailsData?.scoringTable?.map((item, index) => (`${item?.judgeLetter} - ${item?.judgeName}${(index !== showClassHorseSoringDetailsData?.scoringTable?.length) && ` , `} `))}
            </sub>
        </div>
    )
}
